import { Component, Input } from '@angular/core';
import { BloomingTimeAggregate } from '../../report/types/blooming-time-aggregate';

interface DrawPoint {
  x: number;
  y: number;
  class: string;
  title?: string;
}

@Component({
  selector: 'app-blooming-times',
  templateUrl: './blooming-times.component.html',
  styleUrls: ['./blooming-times.component.scss'],
  standalone: false
})
export class BloomingTimesComponent {
  drawPoints: DrawPoint[] = [];
  readonly DIAGRAM_SIZE = 120;
  readonly yStart = 3.5;
  readonly yEnd = 16.5;
  readonly textY = 25;
  readonly pointY = 9.5;
  readonly pointSize = 5;
  readonly monthTicks = [
    { x: 3, label: '1' },
    { x: 13, label: '2' },
    { x: 23, label: '3' },
    { x: 33, label: '4' },
    { x: 43, label: '5' },
    { x: 53, label: '6' },
    { x: 63, label: '7' },
    { x: 73, label: '8' },
    { x: 83, label: '9' },
    { x: 93, label: '10' },
    { x: 103, label: '11' },
    { x: 113, label: '12' },
  ];

  @Input() set aggregates(aggregates: BloomingTimeAggregate[]) {
    this.drawPoints = (aggregates || [])
      .map((item) => ({
        x: this.getX(item.bin),
        y: this.pointY,
        class: this.getClass(item.sightings),
        // title: `${item.year}: ${item.sightings}`,
      }));
  }

  private getX(bin: number) {
    const widthPerBin = this.DIAGRAM_SIZE / 24;
    return (bin - 0.5) * widthPerBin;
  }

  private getClass(sightings: number) {
    if (sightings <= 2) {
      return 'density-low';
    }
    if (sightings <= 5) {
      return 'density-medium';
    }
    if (sightings <= 15) {
      return 'density-high';
    }
    return 'density-max';
  }
}
